import EventEmitter from "events";
const emitter = new EventEmitter();
emitter.setMaxListeners(150);
export default emitter;
